'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _taxonomyNodePropType = require('../PropTypes/taxonomyNodePropType');

var _taxonomyNodePropType2 = _interopRequireDefault(_taxonomyNodePropType);

var _generateSlug = require('../helpers/generateSlug');

var _generateSlug2 = _interopRequireDefault(_generateSlug);

var _subregionPagePath = require('../helpers/subregionPagePath');

var _subregionPagePath2 = _interopRequireDefault(_subregionPagePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderSubregion = function RenderSubregion(_ref) {
  var subregion = _ref.subregion,
      onClickLink = _ref.onClickLink;

  var getHref = function getHref(_ref2) {
    var associated = _ref2.associated,
        _id = _ref2._id,
        name = _ref2.name;

    if (associated) {
      return associated.links.find(function (link) {
        return link.key === 'www';
      }).href;
    }
    var slug = (0, _generateSlug2.default)(name);
    return (0, _subregionPagePath2.default)(_id, slug);
  };

  return _react2.default.createElement(
    'div',
    { className: 'quiver-render-subregion' },
    _react2.default.createElement(
      'a',
      {
        href: getHref(subregion),
        onClick: function onClick() {
          return onClickLink({
            clickEndLocation: 'Region Forecast',
            destinatonUrl: getHref(subregion),
            completion: true,
            linkName: subregion.name
          }, true);
        }
      },
      subregion.name
    )
  );
};

RenderSubregion.propTypes = {
  subregion: _taxonomyNodePropType2.default,
  onClickLink: _propTypes2.default.func
};

RenderSubregion.defaultProps = {
  onClickLink: null
};

exports.default = RenderSubregion;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/RenderSubregion/RenderSubregion.js
// module id = 321
// module chunks = 0